import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import $ from "jquery";
export default function dataTableGrid(options) {
  $(document).ready(function () {
    // setTimeout(function () {
    $(options["data_table_id"]).DataTable({
      pagingType: "full_numbers",
      pageLength: 100,
      processing: true,
      dom: "Bfrtip",
      buttons: [
        {
          extend: "copy",
          attr: { id: "allan" },
          text: '<i className="la la-copy"></i> Copy',
          exportOptions: { columns: options["copy_option"] },
        },
        {
          extend: "csv",
          text: '<i className="la la-file-excel-o"></i> Excel',
          exportOptions: { columns: options["csv_option"] },
        },
        {
          extend: "print",
          text: '<i className ="la la-print"></i> Print',
          exportOptions: { columns: options["print_option"] },
        },
      ],
      aoColumnDefs: [
        {
          bSortable: false,
          aTargets: options["sort_option"] /* 1st one, start by the right */,
        },
      ],
      exportOptions: {
        columns: options["csv_option"],
      },
      bDestroy: true,
      scrollY: "95vh",
      scrollCollapse: true,
      searching: true,
      ordering: true,
      bPaginate: options["paginate"],
      bInfo: false,
      retrieve: true,
    });
    // }, 500);
  });
}
